class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class NavigatorDisclosure extends HTMLElement {
  constructor() {
    super();
    // 修改点1：将 details 改为 .details_nav
    this.navigator = this.querySelector(".details_nav");
    this.debounceTimeout = 100;
    this.animationDuration = 500;
    this.isAnimating = false;

    this.navigator && 
      this.navigator.addEventListener("click", this.onNavigatorClick.bind(this));
    
    document.addEventListener("scroll", this.update.bind(this));
    document.querySelectorAll(".second_nav").forEach(secondNav => 
      secondNav.addEventListener("click", this.onsecondNavClick.bind(this))
    );
  }
  onNavigatorClick(event) {
      if (this.isAnimating)
          return;
      const secondNav = this.querySelector(".second_nav")
        , currentLi = this.closest("li");
      document.querySelectorAll("navigator-disclosure").forEach(element => {
          if (element !== this) {
              element.classList.remove("active");
              const otherSecondNav = element.querySelector(".second_nav");
              otherSecondNav && this.hideNav(otherSecondNav);
              const otherLi = element.closest("li");
              otherLi && otherLi.classList.remove("open")
          }
      }
      ),
      secondNav.style.visibility === "visible" ? (this.hideNav(secondNav),
      this.classList.contains("active") && this.classList.remove("active"),
      currentLi && currentLi.classList.contains("open") && currentLi.classList.remove("open")) : (this.showNav(secondNav),
      this.classList.contains("active") || this.classList.add("active"),
      currentLi && !currentLi.classList.contains("open") && currentLi.classList.add("open"))
  }
  showNav(secondNav) {
      this.clearAnimations(secondNav),
      this.isAnimating = !0,
      secondNav.style.visibility = "visible",
      secondNav.style.opacity = 0,
      requestAnimationFrame( () => {
          secondNav.classList.add("transition"),
          secondNav.style.opacity = 1,
          setTimeout( () => {
              this.isAnimating = !1
          }
          , this.animationDuration)
      }
      ),
      Array.from(secondNav.children).forEach( (element, index) => {
          this.clearAnimations(element),
          element.style.opacity = 0,
          requestAnimationFrame( () => {
              element.classList.add("transition"),
              setTimeout( () => {
                  element.style.opacity = 1
              }
              , index * 100)
          }
          )
      }
      )
  }
  hideNav(secondNav) {
      this.clearAnimations(secondNav),
      this.isAnimating = !0,
      secondNav.classList.add("transition"),
      secondNav.style.opacity = 0,
      setTimeout( () => {
          secondNav.classList.remove("transition"),
          secondNav.style.visibility = "hidden",
          this.isAnimating = !1
      }
      , this.animationDuration),
      Array.from(secondNav.children).forEach(element => {
          this.clearAnimations(element),
          element.classList.add("transition"),
          element.style.opacity = 0
      }
      )
  }
  update() {
      (window.pageYOffset || document.documentElement.scrollTop) > 10 && (document.querySelectorAll(".second_nav").forEach(secondNav => {
          this.hideNav(secondNav)
      }
      ),
      document.querySelectorAll("navigator-disclosure").forEach(element => {
          element.classList.remove("active")
      }
      ))
  }
  onsecondNavClick(event) {
      event.stopPropagation()
  }
  clearAnimations(element) {
      element.classList.remove("transition"),
      element.style.transition = "none",
      requestAnimationFrame( () => {
          element.style.transition = ""
      }
      )
  }
}
customElements.define("navigator-disclosure", NavigatorDisclosure),
Element.prototype.siblings = function() {
  return this.parentNode 
    ? Array.from(this.parentNode.children).filter(child => child !== this) 
    : [];
};

// 修改点3：修改全局点击事件监听器中的 details 为 .details_nav
document.addEventListener("click", function(e) {
  // 将 closest("details") 改为 closest(".details_nav")
  if (!e.target.closest(".details_nav")) {
    document.querySelectorAll(".second_nav").forEach(secondNav => {
      secondNav.style.visibility = "hidden";
      secondNav.style.opacity = 0;
      secondNav.style.transform = "translateY(-10px)";
    });
    
    document.querySelectorAll("navigator-disclosure").forEach(element => {
      element.classList.remove("active");
    });
  }
});